// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1041":"639fe943","1055":"cce92c22","4573":"cce92c22","6180":"5cc3829b","7900":"7796e402","8885":"863eda24"}[chunkId] + ".chunk.css";
};